export const catalogue = [
  {
    id: 1,
    name: "IMPERMEABLE PREMIUM VETROX TALLA ÚNICA (10%)",
    img: "https://www.promohavoline.com/catalogue/impermeable_premium_vetrox.jpg",
    description1:
      "Este impermeable está hecho en poliéster recubierto con PVC y costuras termoselladas, para asegurar que no se filtre ni una gota de lluvia. Además, es vulcanizado, por lo que lo hace ideal para viajes largos por la carretera o para las rodadas diarias en la ciudad.",
    description2: ""
  },
  {
    id: 2,
    name: "PAR DE CORREAS TRINQUETE TEREK",
    img: "https://www.promohavoline.com/catalogue/correas_trinquete_terek.jpg",
    description1:
      "Las Correas Trinquete Terek están diseñadas para ayudarlo a sujetar cargas a su motocicleta (Que no superen la capacidad de carga de la moto) y moverlas con seguridad por la ciudad. También, puede usar estas correas para asegurar su moto cuando sea necesario.",
    description2: ""
  },
  {
    id: 3,
    name: "INTERCOMUNICADOR FREDCONN VB (10%)",
    img: "https://www.promohavoline.com/catalogue/intercomunicador_fredconn.jpg",
    description1:
      "Perfecto para recibir llamadas con seguridad mientras conduce, el Intercomunicador Fredconn cuenta con tecnología bluetooth de última generación 4.0 para poder recibir y realizar llamadas desde su celular sin tener que tocarlo. Sus materiales lo hacen resistente al agua y el compañero ideal para los motociclistas viajeros que necesitan una ayuda del GPS para guiarse en carretera.",
    description2: ""
  },    
  {
    id: 4,
    name: "EXPLORADORA LED",
    img: "https://www.promohavoline.com/catalogue/EXPLORADORA_LED.jpg",
    description1:
      "Esta es la primera exploradora LED o luz auxiliar para motocicletas diseñada y fabricada en Colombia, capaz de soportar, no solo condiciones de lluvia extrema, sino también las vibraciones constantes de la moto. Su bombillo LED de 750 lumens le brinda un bajo consumo de la batería.",
    description2: ""
  },
  {
    id: 5,
    name: "SERVICE JACK (PATA SOPORTE)",
    img: "https://www.promohavoline.com/catalogue/SERVICE_JACK_PATA_SOPORTE.jpg",
    description1:
      "El gato de servicio MASTECH es una práctica herramienta para los motociclistas apasionados por su moto. Está diseñado para complementar el mantenimiento de las motos que no cuentan con un gato central (Sport, súper sport, sport touring, etc).",
    description2:
      "Es portable, fácil de usar y funciona muy bien a la hora de realizar los mantenimientos preventivos de la motocicleta."
  },
  {
    id: 6,
    name: "SOPORTE CASCO PARA PARED MASTECH",
    img: "https://www.promohavoline.com/catalogue/SOPORTE_CASCO_PARA_PARED_MASTECH.jpg",
    description1:
      "Un motociclista apasionado se preocupa por mantener sus accesorios de seguridad en buen estado y a la mano. Por eso, la marca MASTECH ha diseñado este soporte para mantener sus accesorios de seguridad bien organizados. Es perfecto para instalarlo en su casa, la oficina o el taller; ya que solo son necesarios cuatro tornillos para anclarlo a cualquier pared.",
    description2: "",
    description3: ""
  },
  {
    id: 7,
    name: "MALETERO PARA MOTO CARGO CASE NEGRO",
    img: "https://www.promohavoline.com/catalogue/MALETERO_PARA_MOTO_CARGO_CASE_NEGRO.jpg",
    description1:
      "¡El mejor maletero de FireParts, ahora con catadióptrico color negro!",
    description2:
      "Este baúl incorpora en su diseño un espaldar para brindarle una mayor comodidad al acompañante o parrillero. Cuenta con amplia capacidad, perfecta para guardar un casco y un impermeable al mismo tiempo. Su instalación es fácil y rápida. ",
    description3:
      "*Para instalarla se necesita de un herraje o soporte para baúl de moto. Se recomienda usar un herraje marca FireParts."
  },
  {
    id: 8,
    name: "SOPORTE CELULAR RIGIDO",
    img: "https://www.promohavoline.com/catalogue/SOPORTE_CELULAR_RIGIDO.jpg",
    description1:
      "Este es el estuche es ideal para su moto, pues puede usarlo para llevar su celular mientras tiene activo el GPS para viajar por carretera. Sus materiales no interfieren con la función táctil del teléfono y su instalación es muy fácil. ",
    description2:
      "Incluye un soporte para manubrios de 7/8” o 1-1/4” y adaptadores de neopreno para evitar tallarlo."
  },
  {
    id: 19,
    name: "MALETERO PARA MOTO WORK CASE",
    img: "https://www.promohavoline.com/catalogue/MALETERO_PARA_MOTO_WORK_CASE.jpg",
    description1:
      "Este baúl es la opción más práctica para aquellos motociclistas que usan su moto en el día a día y que requieren almacenar con seguridad sus pertenencias. Cuenta con una capacidad de 30 litros, perfecta para almacenar un casco y un par de guantes. Este baúl incluye su propio soporte, el cual hace que instalarlo sea muy fácil y rápido.",
    description2: ""
  },
  {
    id: 10,
    name: "MALETERO PARA MOTO NUCLEON CASE 40 LITROS",
    img: "https://www.promohavoline.com/catalogue/MALETERO_PARA_MOTO_NUCLEON_CASE_40_LITROS.jpg",
    description1:
      "¡Lo último de FireParts en maleteros para moto de gran capacidad! ",
    description2:
      "Este baúl incorpora en su diseño un espaldar para brindarle una mayor comodidad al acompañante o parrillero. Cuenta con una capacidad de 40 litros para guardar todo lo que necesites. Además, su instalación es muy fácil.",
    description3:
      "*Para instalarla se necesita de un herraje o soporte para baúl de moto. Se recomienda usar un herraje marca FireParts."
  },
  {
    id: 11,
    name: "ALFORJAS TEREK DRY BAG 20 LT AMARILLA",
    img: "https://www.promohavoline.com/catalogue/Alforjas_Terek_Dry_Bag _20_LT_Amarilla.jpg",
    description1:
      'Las alforjas textiles Terek hacen parte de la línea "Dry bag ", una línea pensada para solucionar las necesidades del Moto-viajero. Cuentan con una gran capacidad de 20 litros y están elaboradas con un material Polimérico-Textil y uniones termoselladas que ofrecen una fácil limpieza y protección total ante las adversidades del clima.',
    description2: ""
  },
  {
    id: 12,
    name: "SOPORTE PARA CELULAR DE SILICONA",
    img: "https://www.promohavoline.com/catalogue/SOPORTE_PARA_CELULAR_DE_SILICONA.jpg",
    description1:
      "Este soporte para celular es ideal para todo tipo de motociclistas, ya que les permite montar con facilidad su smartphone en el manubrio y ver todo lo que sucede en la pantalla mientras conduce. Ideal para viajeros que usan el GPS para guiarse por carretera y conocer nuevos lugares con sus motocicletas.",
    description2: ""
  },
  {
    id: 13,
    name: "SOPORTE CASCO PARA PARED FIREPARTS",
    img: "https://www.promohavoline.com/catalogue/SOPORTE_CASCO_PARA_PARED_FIREPARTS.jpg",
    description1: "Un motociclista apasionado se preocupa por mantener sus accesorios de seguridad en buen estado y a la mano. Por eso, la marca FireParts ha diseñado este soporte para mantener sus accesorios de seguridad bien organizados. Es perfecto para instalarlo en su casa, la oficina o el taller; ya que solo son necesarios dos tornillos para anclarlo a cualquier pared.",
    description2: ""
  },
  {
    id: 14,
    name: "CORREAS QUICK STRAPS MASTECH",
    img: "https://www.promohavoline.com/catalogue/CORREAS_QUICK_STRAPS_MASTECH.jpg",
    description1: 'Las Correas Quick Straps de MASTECH están fabricadas con reata de seguridad de alta resistencia (1") para ayudarlo a sujetar diferentes tipos de cargas a su motocicleta (de máximo 94 kg) y moverlas con facilidad por la ciudad. ',
    description2: ""
  },
  {
    id: 15,
    name: "PROTECTOR DE CALZADO",
    img: "https://www.promohavoline.com/catalogue/PROTECTOR_DE_CALZADO.jpg",
    description1: "Estos protectores le ayudan a evitar las manchas y el deterioro en los zapatos que se produce por el roce con la palanca de cambios de la motocicleta.",
    description2: ""
  },
  {
    id: 16,
    name: "PUERTO CONEXIÓN 12v PARA MOTO",
    img: "https://www.promohavoline.com/catalogue/PUERTO_CONEXIÓN_12v_PARA_MOTO.jpg",
    description1: "Cargue su celular u otros dispositivos mientras conduce con este cargador USB de 12 voltios. El cargador incluye cable USB de 1.50 mts, soporte para manubrio (7/8 o 11/8) y fusible de repuesto. ",
    description2: ""
  }
];
